// extracted by mini-css-extract-plugin
export default {"container":"CodeMirrorDiff-module__container--RCtmx","newFile":"CodeMirrorDiff-module__newFile--vX9DQ","deletedFile":"CodeMirrorDiff-module__deletedFile--_w4wx"};